export const languagePreferenceKey = 'borgee.languagePreference';

export interface LanguageEnvironment {
  readPreference: () => string | null;
  writePreference: (preference: string) => void;
  getLanguages: () => readonly string[];
  subscribe: (onPreferenceChange: () => void, onLanguagesChange: () => void) => () => void;
  setDocumentLanguage: (locale: string) => void;
  reportError: (error: Error) => void;
}

export const createBrowserLanguageEnvironment = (): LanguageEnvironment => ({
  readPreference: () => window.localStorage.getItem(languagePreferenceKey),
  writePreference: preference => window.localStorage.setItem(languagePreferenceKey, preference),
  getLanguages: () => navigator.languages,
  subscribe: (onPreferenceChange, onLanguagesChange) => {
    const onStorage = (event: StorageEvent) => {
      if (event.key !== null && event.key !== languagePreferenceKey) return;
      // Access to localStorage may be denied. Preference reads own that error
      // boundary, so unrelated storage events must not access it unnecessarily.
      let localStorage: Storage;
      try {
        localStorage = window.localStorage;
      } catch {
        onPreferenceChange();
        return;
      }
      if (event.storageArea === localStorage) onPreferenceChange();
    };
    window.addEventListener('storage', onStorage);
    window.addEventListener('languagechange', onLanguagesChange);
    return () => {
      window.removeEventListener('storage', onStorage);
      window.removeEventListener('languagechange', onLanguagesChange);
    };
  },
  setDocumentLanguage: locale => { document.documentElement.lang = locale; },
  reportError: error => { console.error(error); },
});
